/*
File: 礼物收益商品账单
Author: SimonLu<luzuoqing@huya.com>
Date: 2020-03-17
*/

import React, { useMemo, useState, useCallback } from 'react'
import * as R from 'ramda'
import BillWithDate from './BillWithDate'
import { extGoodsBackPaySummary, extGoodsBackPayDetail } from '@/api/api'
import * as dateFns from 'date-fns/fp'
import { Modal, Button, Table } from 'antd'

import { useAction } from '@/hooks/useAction'
import PaginationTable from '@cmps/PaginationTable/PaginationTable'

const initStartTime = dateFns.startOfMonth(new Date())
const initEndTime = dateFns.endOfMonth(new Date())

const log = R.tap(console.log)

const formatDate = R.converge(
  R.unapply(R.join('-')),
  [
    R.slice(0, 4),
    R.slice(4, 6),
    R.slice(6, 8),
  ],
)

// input: yyyyMMDD
// output: yyyy-MM
const formatMonth = R.converge(
  R.unapply(R.join('-')),
  [
    R.slice(0, 4),
    R.slice(4, 6),
  ])


const detailColumns = [
  {
    title: '日期',
    dataIndex: 'statementDate',
  },
  {
    title: '商品名',
    dataIndex: 'goodsName',
  },
  {
    title: '累计使用计数(金豆)',
    dataIndex: 'latestTotalData',
  },
  {
    title: '金额(虎牙币)',
    dataIndex: 'latestExpense',
    render: (value, row) => <span>{ parseInt(R.min(value, R.defaultTo(Infinity, row.maxFee)), 10) / 100 }</span>,
  },
]

const transformer = R.compose(
  R.map(R.evolve({
    expenseDate: R.pipe(R.toString, formatMonth),
    settleTotal: R.pipe(parseInt, R.divide(R.__, 100)),
  })),
  R.defaultTo([]),
  R.prop('data'),
)

const detailTransformer = R.compose(
  R.map(R.evolve({
    statementDate: R.pipe(R.toString, formatMonth),
  })),
  R.defaultTo([]),
  R.prop('data'),
)


function PostOrderBill() {
  const [isDetailVisible, toggleDetail] = useState(false)
  const [detailData, setDetailData] = useState(null)

  const [detailState, performGetDetail] = useAction(extGoodsBackPayDetail)

  // 保存获取详情需要的入参
  const [detailParam, setDetailParam] = useState({
    extUuid: null,
    month: null,
  })

  const handleClickDetail = useCallback(record => {
    console.log(record)

    setDetailParam({
      extUuid: record.extUuid,
      month: R.pipe(R.prop('expenseDate'), R.split('-'), R.take(2), R.join('-'))(record),
    })

    toggleDetail(true)
  }, [])


  const columns = useMemo(() => [
    {
      title: '日期',
      dataIndex: 'expenseDate',
      // render: value => <span>{ formatDate(value.toString()) }</span>
    },
    {
      title: '小程序名',
      dataIndex: 'extName',
    },
    {
      title: '付费金额(虎牙币)',
      dataIndex: 'settleTotal',
      // render: text => <span>{parseInt(text, 10) / 100}</span>
    },
    {
      title: '操作',
      render: (text, record, index) => (
        <div>
          <Button size="small" onClick={() => handleClickDetail(record)}>查看详情</Button>
        </div>
      ),
    },
  ], [])

  return (
    <div>
      <BillWithDate
        fetcher={extGoodsBackPaySummary}
        columns={columns}
        initStartTime={initStartTime}
        initEndTime={initEndTime}
        transformer={transformer}
      />

      <Modal
        title="付费商品明细"
        visible={isDetailVisible}
        onOk={() => toggleDetail(false)}
        onCancel={() => toggleDetail(false)}
        footer={null}
        key={JSON.stringify(detailParam)}
        bodyStyle={{padding: '0'}}
        width={540}
      >
        <PaginationTable
          fetcher={pageParam => extGoodsBackPayDetail({ ...pageParam, ...detailParam })}
          transformer={detailTransformer}
          columns={detailColumns}
        />
      </Modal>
    </div>
  )
}

export default PostOrderBill
